<template>
  <section class="tool position-relative" :class="{ 'tool--loading': loading }">

    <loader :loading="loading" class="position-absolute"></loader>

    <div class="tool__memberships js-material-form material-form position-relative pt-4 pt-md-5 pt-lg-6"
         :class="{ 'fade': loading }"
    >
      <div class="container">
        <div class="row pb-2">
          <div class="col-12 col-sm-10 col-md-8 col-xl-6">
            <h2 class="tool__product-title" v-if="dataObject.title" v-html="dataObject.title"></h2>
            <div class="tool__product-description" v-if="dataObject.description" v-html="dataObject.description"></div>
          </div>
        </div>
        <div class="row pb-3">
          <ToolFormInput
            type="select"
            :label="dataObject.label.selectDuration"
            defaultOptionLabel="Ben je starter?"
            name="type_membership"
            id="tool_membership"
            :disabled="false"
            :required="true"
            :errorMessage="dataObject.formErrors.required"
            classes="mt-3 col-12 col-sm-8 col-lg-4"
            :options="durationTypes"
            v-model="type"
            :isMobile="dataObject.isMobile"
            returnAs="string"
          />
        </div>
        <div v-if="type" class="animated position-relative tool__membership-starter" :class="{
          'fadeInUp': type,
          'fadeOutDown': !type
        }">
          <div class="row pb-3">
            <ToolFormInput
              type="select"
              :label="dataObject.label.selectTool"
              :defaultOptionLabel="label('', dataObject.label.selectTool)"
              name="type_membership_starter"
              id="tool_membership_starter"
              :disabled="false"
              :required="true"
              :errorMessage="dataObject.formErrors.required"
              classes="mt-3 col-12 col-sm-8 col-lg-4"
              :options="types"
              v-model.number="selectedStarter"
              :isMobile="dataObject.isMobile"
              returnAs="number"

              indexIncrease="1"
            />
          </div>
        </div>
        <div class="row pt-4 pb-3" v-if="type === 'starter' && tools[selectedIndex] && selectedStarter > 0">
          <ToolBadge
            :value="toInterger(tools[selectedIndex].price)"
            :valueReadable="euro(toInterger(tools[selectedIndex].price))"
            classes="tool__badge-wrapper col-12 col-sm-8 col-md-auto col-lg-auto animated d-flex flex-row align-items-center text-nowrap justify-content-between justify-content-lg-start mb-4 mb-lg-0 order-3 order-md-2"
            inputClasses="tool__badge--large bg-primary"
            :label="dataObject.label.membership + ':'"
          ></ToolBadge>
        </div>

        <div v-if="selectedStarter > 0 && type === 'entrepreneur'"
             class="animated position-relative tool__membership-starter" :class="{
          'fadeInUp': type === 'entrepreneur' && tools[selectedIndex],
          'fadeOutDown': type !== 'entrepreneur' && !tools[selectedIndex]
        }">
          <div class="row mt-4 mt-md-5">
            <div class="col-12 col-lg-8 col-xl-6">
              <h6 v-if="tools[selectedIndex].title" v-html="tools[selectedIndex].title"></h6>
              <div v-if="tools[selectedIndex].description" v-html="tools[selectedIndex].description"></div>
            </div>
          </div>
          <div class="row">
            <ToolFormInput
              type="select"
              :label="tools[selectedIndex].tools_label"
              :defaultOptionLabel="label(tools[selectedIndex].tools_option_label, tools[selectedIndex].tools_label)"
              :name="'type_' + type + '-' + selectedIndex"
              :id="'type_' + type + '-' + selectedIndex"
              :disabled="false"
              :required="true"
              :errorMessage="dataObject.formErrors.required"
              classes="mt-3 col-12 col-sm-8 col-lg-4"
              :options="tools[selectedIndex].tools"
              v-model="selectedOptions[selectedIndex]"
              :isMobile="dataObject.isMobile"
            />

            <ToolBadge
              v-if="selectedOptions[selectedIndex] && !isNaN(selectedOptions[selectedIndex])"
              :value="toInterger(selectedOptions[selectedIndex])"
              :valueReadable="euro(toInterger(selectedOptions[selectedIndex]))"
              classes="col-12 col-sm-8 col-md-auto col-lg-auto animated d-flex flex-row align-items-center text-nowrap justify-content-between justify-content-lg-start mb-4 mt-3 mt-sm-4 mb-lg-0 order-3 order-md-2"
              inputClasses="tool__badge--large bg-primary"
              :label="dataObject.label.membership + ':'"
            ></ToolBadge>
          </div>
        </div>
        <div v-if="formVisible" class="row position-relative tool__membership-starter tool__membership-starter--form animated mt-4 mt-md-5" :class="{
          'fadeInUp': formVisible,
          'fadeOutDown': !formVisible
        }">
          <div class="col-12 col-lg-10">
            <a :href="dataObject.label.button.url"
               :title="dataObject.label.button.title"
               :target="dataObject.label.button.target"
               class="btn btn-secondary btn-lg"
               v-html="dataObject.label.button.title"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ToolFormInput from "./ToolFormInput";
import ToolBadge from "./ToolBadge";
import ToolForm from "./ToolForm";
import Loader from './Loader';

export default {
  name: 'ToolMembership',
  props: {
    objects: {
      type: String,
      required: false
    },
    dataset: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      loading: true,
      type: '',
      selectedStarter: 0,
      selectedOptions: []
    }
  },
  mounted() {

    let self = this;
    setTimeout(function () {
      // Make sure we don't see weird animation on load
      self.loading = false;
    }, 2000);

  },

  computed: {

    /**
     * Returns boolean for if form is visible or not.
     * @return {Boolean}
     */
    formVisible() {
      return (this.type === 'starter' && this.selectedStarter > 0)
        || (this.type === 'entrepreneur' && this.selectedStarter > 0 && this.selectedOptions.length > 0 && this.selectedOptions[this.selectedIndex] && !isNaN(this.selectedOptions[this.selectedIndex]));
    },

    selectedIndex() {
      return this.selectedStarter - 1;
    },

    // Set products from parsed Data
    tools() {
      return JSON.parse(this.objects);
    },

    dataObject() {
      return JSON.parse(this.dataset);
    },

    /**
     * Duration Types
     * @returns {({name: *, value: string}|{name: *, value: string})[]}
     */
    durationTypes() {
      return [
        {name: this.dataObject.label.starter, value: 'starter'},
        {name: this.dataObject.label.entrepreneur, value: 'entrepreneur'},
      ];
    },

    /**
     * Types, only populate when price is bigger than 0
     * @returns {({name: *, value: string}|{name: *, value: string})[]}
     */
    types() {
      let data = [];
      for (let i = 0, j = this.tools.length; i < j; i++) {
        if (parseFloat(this.tools[i].price) > 0) {
          data.push({
            name: this.tools[i].title,
            value: i + 1, // this.toInterger(this.tools[i].price)
          });
        }
      }
      return data;
    }
  },

  methods: {
    /**
     * Return interget into readable Euro logic
     * @param int
     * @returns {string}
     */
    euro(int) {
      return new Number(int).toLocaleString("nl-NL", {
        style: "currency",
        currency: "EUR"
      });
    },

    /**
     * force string to Interger
     * @returns {Number}
     */
    toInterger(string) {
      if (!string) {
        return 0;
      }

      return parseFloat(string);
    },

    /**
     * Set label for select
     * @param value
     * @param label
     * @returns {*}
     */
    label(value, label) {
      if (!value) {
        return this.dataObject.label.defaultSelect.replace('%s', label.toLowerCase())
      }
      return value;
    },

  },
  components: {
    Loader,
    ToolBadge,
    ToolFormInput
  }
}
</script>
